import { Box } from "styles/globalComponents";
import { Eye, CalendarDays } from "lucide-react";

import { formatBRLCurrency } from "Utils/FormatCurrency";

import { ListClientBudget } from "Dtos/IBudget";
import { BUDGETSTATUS } from "Constants/Budget";
import { TableItemStyle } from "../styles";

export interface TableBodyProps {
  listBudget: ListClientBudget;
  setScheduleInfo: (params: ScheduleInfo) => void;
}

export type ScheduleInfo = {
  id: number; // acuity_id
  clientId: number;
  preOrderId: number;
  zipcode: string;
};

export const TableItem = ({ listBudget, setScheduleInfo }: TableBodyProps) => {
  let date = "";
  let time = "";
  let patientSchedule = "Não informado";

  if (listBudget.cli_pre_budget.appointment_at) {
    const [d, t] = listBudget.cli_pre_budget.appointment_at?.split(" ") || [];
    const [yyyy, mm, dd] = d?.split("-");
    time = t?.slice(0, 5);
    date = `${dd}/${mm}/${yyyy}`;
    patientSchedule = `${date} - ${time}`;
  }

  const onSetScheduleInfo = () => {
    const schedule = {
      id: listBudget.cli_pre_budget.acuity_id,
      clientId: listBudget.cli_pre_budget.client.id,
      preOrderId: listBudget.cli_pre_budget.id,
      zipcode: listBudget.cli_pre_budget.address.zipcode.replace("-", ""),
    };
    setScheduleInfo(schedule);
  };

  const onRedirectToBudget = () =>
    window.open(`/ficha-de-atendimento-parceiro/${listBudget.id}/domiciliar`);

  const hasToRemoveCalendarIcon = [
    BUDGETSTATUS.canceled,
    BUDGETSTATUS.converted,
  ].includes(listBudget.status.id);

  return (
    <TableItemStyle>
      <td>{listBudget.id}</td>
      <td>{listBudget.patient?.full_name}</td>
      <td>{patientSchedule}</td>

      <td>{listBudget.patient?.documents[0].number}</td>

      <td>{listBudget.cli_pre_budget.client.name}</td>
      <td>{formatBRLCurrency(listBudget.total)}</td>

      <td>{listBudget.status.status}</td>
      <td>
        <Box display="flex" justify="center">
          {hasToRemoveCalendarIcon ? null : (
            <button onClick={onSetScheduleInfo}>
              <CalendarDays color="purple" />
            </button>
          )}

          <button onClick={onRedirectToBudget}>
            <Eye color="purple" />
          </button>
        </Box>
      </td>
    </TableItemStyle>
  );
};
